import {Field} from "@qid/field";
import {Signature} from "typescript";
import {IdField } from "../../id";
import { User } from "../../user";
import { Organisation } from "../../organisation";
import {ID} from "../../../models/ID";

export class CreateParticipantDto {

    entityId: string;
    entityType: string;
    mandatoryIds: Field<IdField>[] = [];
    optionalIds: Field<IdField>[] = [];
    signature: Signature;
    optionalLabel: string;
    ids: ID[];
    memberId: string;
    entity: User | Organisation;
    otherFields: any;

}
